/*
 * MIT License
 *
 * Copyright (c) 2024 tuxming@sina.com / wechat: angft1
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import React, {useRef} from 'react'
import { Button, ButtonProps,Tooltip } from "antd"
import { useAuth } from "../../hooks";


export type AuthButtonProps = ButtonProps & {
    requiredPermissions: string[] | string,
    tip?: string
};

/**
 * 具有权限的button, 如果有权限，返回antd的btn,如果没有权限，返回空
 */
export const AuthButton = React.forwardRef<HTMLButtonElement, AuthButtonProps>(({
    requiredPermissions,
    tip,
    ...props
}, ref) => {
    
    const auth = useAuth();
    let isPermitted = auth.has(requiredPermissions);

    //解决报错
    const tagRef = ref || useRef<HTMLButtonElement>(null);

    if(tip){
        return isPermitted ? (<Tooltip title={tip}>
           <Button ref={tagRef} {...props}></Button>
        </Tooltip>)
        :<></>
    }else{
        return isPermitted ? <Button ref={tagRef} {...props}></Button> : <></>
    }

})
